// const TicketStatus = [
//     { label: 'New', value: 1 },
//     {  label: 'In Progress', value: 2 },
//     {  label: 'Completed', value: 3 },
//     {  label: 'Re Open', value: 4 },
//     {  label: 'Cancelled', value: 5 },
// ];



const TicketStatus = [
    { label: 'New', value: 1 },
    { label: 'Clarification Needed', value: 21 },
    { label: 'Assigned', value: 6 },
    {  label: 'In Progress', value: 2 },
    {  label: 'Waiting for Development', value: 7 },
    {  label: 'In Development', value: 8 },
    {  label: 'Sent to QA for Testing', value: 9 },
    {  label: 'QA in Progress', value: 10 },
    {  label: 'QA Failed', value: 11 },
    {  label: 'QA Passed', value: 12 },
    {  label: 'Waiting for Client Approval', value: 14 },
    {  label: 'Client Approved', value: 18 },
    {  label: 'Client Rejected', value: 20 },
    {  label: 'Changes Requested', value: 15 },
    {  label: 'Moved to Production', value: 13 },
    {  label: 'Re-opened', value: 4 },
    {  label: 'Escalated', value: 16 },
    {  label: 'Completed', value: 3 },
    {  label: 'Cancelled', value: 5 },
    {  label: 'On Hold', value: 17 },
    {  label: 'Closed', value: 19 },
];


export default TicketStatus;